/**
 * 实名系统中用于调用iframe的页面方便研发使用
 */
import {Button, Input, Modal, Radio, Row, Space, Tag} from '@baidu/qianfan-antd-kit';
import {useEffect, useState} from 'react';
import {SCIndexContainer} from '@/styles/modules';
import {message} from '@/utils/escapeAntd';
import QualifyModalSDK from '@/sdk/QualifyModalSDK';
import type {InitialAuthType} from '@/sdk/QualifyModalSDK/IframeModal';
import IframeTest from './iframe';

interface IframeMessage {
    activateSuccess: boolean;
    qualifySuccess: boolean;
    loginSuccess: boolean;
}

const CHOICE = [
    {
        label: 'IAM用户列表页默认跳转实名',
        key: 'https://login.bcetest.baidu.com/?needQualify=1&redirect=https%3A%2F%2Fqasandbox.bcetest.baidu.com%2Fiam%2F#/account/user/list',
    },
    {label: '登录页默认跳转实名', key: 'https://login.bcetest.baidu.com/?needQualify=1'},
    {label: '登录页不跳转实名', key: 'https://login.bcetest.baidu.com/'},
];

type AuthTypeValue = InitialAuthType | undefined;

const IframePageCheck = () => {
    const [url, setUrl] = useState('#/qualify/index');
    const [show, setShow] = useState(false);
    const [initialAuthType, setInitialAuthType] = useState<AuthTypeValue>();

    useEffect(() => {
        const handleMessage = (e: MessageEvent<IframeMessage>) => {
            if (e.data && (e.data.activateSuccess || e.data.qualifySuccess || e.data.loginSuccess)) {
                message.info(`返回消息${JSON.stringify(e.data)},返回此消息表示iframe关闭`);
                e.data.qualifySuccess && setShow(false);
            }
        };
        window.addEventListener('message', handleMessage, false);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    const onOpen = () => {
        setShow(true);
    };

    const onOpenSDK = () => {
        QualifyModalSDK.show({env: 'sandbox', initialAuthType});
    };

    return (
        <SCIndexContainer>
            <Space>
                {CHOICE.map(cur => (
                    <Tag key={cur.key} onClick={() => setUrl(cur.key)}>
                        {cur.label}
                    </Tag>
                ))}
            </Space>
            <Row style={{marginBottom: 16}}>
                访问的URL
                <Input value={url} onChange={val => setUrl(val.target.value)} />
            </Row>
            <Row style={{marginBottom: 16}}>
                SDK初始认证类型：
                <Radio.Group
                    value={initialAuthType || ''}
                    onChange={event => setInitialAuthType(event.target.value || undefined)}
                    options={[
                        {label: '默认', value: ''},
                        {label: '企业认证', value: 'enterprise'},
                        {label: '个人认证', value: 'personal'},
                    ]}
                />
            </Row>
            <Space>
                <Button type="primary" onClick={onOpen} intensity="strong">
                    查看Iframe
                </Button>
                <Button type="primary" onClick={onOpenSDK} intensity="strong">
                    查看SDK Modal样式
                </Button>
            </Space>
            <Modal
                styles={{
                    body: {
                        padding: 0,
                        lineHeight: '10px',
                    },
                    content: {
                        padding: 0,
                    },
                }}
                width="fit-content"
                open={show}
                footer={null}
                onCancel={() => setShow(false)}
            >
                <IframeTest url={url} />
            </Modal>
        </SCIndexContainer>
    );
};

export default IframePageCheck;
